import React, { Component } from 'react'
import SocialLogin from 'react-social-login'

class Button extends Component {
  render() {
    const { children, triggerLogin, disabled, className } = this.props

    return (
      <button onClick={triggerLogin} disabled={disabled} className={className} >
        { children }
      </button>
    )
  }
}

export default SocialLogin(Button)



// WEBPACK FOOTER //
// ./src/components/SocialButton/index.js